import { updateUser } from "./useUpdateUser";
import type { UserData } from "./useUserData";
import { getUserProfileCompleteness } from "../utils/userProfile";

export function useMaybeUpdateUser(
  userData: UserData | null | undefined,
  isLoggedIn: boolean,
) {
  const { isProfileComplete } = isLoggedIn
    ? getUserProfileCompleteness(userData)
    : { isProfileComplete: false };

  const maybeUpdateUser = async (
    mobile: string | undefined,
    countryCode: string | undefined,
    saveToAccount: boolean,
    firstName: string | undefined,
    lastName: string | undefined,
    email: string | undefined,
  ) => {
    if (!isLoggedIn || !userData) return;
    if (!saveToAccount) return;
    if (isProfileComplete) return;

    const fullPhone = `${(countryCode ?? "").replace(/^\+/, "")} ${mobile ?? ""}`;

    const updatePhone =
      !!mobile?.trim() && fullPhone !== (userData.phonenumber?.trim() ?? "");
    const updateFirstName =
      !!firstName?.trim() &&
      (firstName?.trim() ?? "") !== (userData.firstName?.trim() ?? "");
    const updateLastName =
      !!lastName?.trim() &&
      (lastName?.trim() ?? "") !== (userData.lastName?.trim() ?? "");
    const updateEmail =
      !!email?.trim() &&
      (email?.trim() ?? "") !== (userData.email?.trim() ?? "");

    if (!updatePhone && !updateFirstName && !updateLastName && !updateEmail)
      return;
    await updateUser(
      userData,
      {
        phonenumber: fullPhone,
        firstName,
        lastName,
        email,
      },
      {
        phonenumber: updatePhone,
        firstName: updateFirstName,
        lastName: updateLastName,
        email: updateEmail,
      },
    );
  };

  return { maybeUpdateUser };
}
